module.exports = __webpack_public_path__ + "static/img/day2.8ae641f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/day2.jpg
// module id = w/j2
// module chunks = 0